import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  imports: [],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss'
})
export class AuthCallbackComponent {
  constructor(private route: ActivatedRoute) { }
  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('accesToken'); // or use fragment if Google uses #

    if (window.opener && token) {
      window.opener.postMessage({ token }, window.location.origin);
      window.close();
    } else {
      console.error('No token found or no opener window.');
    }
  }
}
